<div class="layout-topbar">
  <button #menubutton p-button
    [class]="menuHidden ? 'p-link layout-topbar-button' : 'p-link layout-menu-button layout-topbar-button'"
    (click)="layoutService.onMenuToggle(); toggle()">
    <i class="pi pi-bars"></i>
  </button>
  <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>
  <div #topbarmenu class="layout-topbar-menu"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }">
    <app-notification></app-notification>
    <button class="p-link layout-topbar-button ml-3" (click)="showProfile()" #profile>
      <i class="pi pi-user link"></i>
      <span>{{ userCopie.firstname + " " + userCopie.lastname }}
        {{ userCopie.defaultShop && userCopie.defaultShop?.shopName ? " - " + userCopie.defaultShop?.shopName : ""
        }}</span>
    </button>
  </div>
</div>
@if(user) {
<p-dialog [(visible)]="visible" (onHide)="hideModal()" [dismissableMask]="false" [modal]="true"
  [style]="{ width: '45rem', height: '50rem' }" draggable="false" styleClass="profile-dialog">
  <ng-template #header>
    <div class="flex justify-content-between align-items-center w-full">
      <div class="inline-flex align-items-center gap-2">
        <p-avatar image="https://ui-avatars.com/api/?name={{ userCopie.firstname + '+' + userCopie.lastname }}"
          shape="circle" />
        <span class="font-bold white-space-nowrap">{{ userCopie.firstname + " " + userCopie.lastname }}</span>
      </div>
      <p-button severity="secondary" [text]="true">
        <i class="pi pi-power-off"></i>
        <span class="pl-2 font-bold link-secondary" (click)="logout()">{{'buttons.logout' | translate}}</span>
      </p-button>
    </div>
  </ng-template>
  <div style="min-height: 350px; padding-bottom: 34px">
    <app-user-detail [editable]="editable" [data]="user" (changed)="changeBtnStatus($event)" (closeDialog)="closeDialog()"
      #userDetail (formValid)="formValid($event)"></app-user-detail>
  </div>
  <ng-template #footer>
    <p-button type="button" icon="pi pi-user-edit" [outlined]="true" (click)="editable = true"
      label="{{'buttons.edit' | translate}}" [hidden]="editable"></p-button>
    <p-button type="button" icon="pi pi-times-circle" [outlined]="true" (click)="hideModal()"
      label="{{'buttons.cancel' | translate}}" [hidden]="!editable" severity="secondary"></p-button>
    <p-button type="button" icon="pi pi-check-square" [outlined]="formNotTouch" (click)="updateForm()"
      label="{{'global.validateModifications' | translate}}" [hidden]="!editable"
      [disabled]="!buttonEnabled"></p-button>
  </ng-template>
</p-dialog>
}


<p-toast></p-toast>